









import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {卸型} from '@/type/wholesale/wholesale';
import {マスタ選択区分型, 商品区分型} from '@/type/wholesale/types';

@Component({})
export default class WholesaleSelector extends Vue {
  @Prop({default: null})
  private value!: string | null;
  @Prop({default: true})
  private nullable!: boolean;
  @Prop({default: 商品区分型.指定なし})
  private productType!: 商品区分型;
  @Prop({default: マスタ選択区分型.指定なし})
  private masterType!: マスタ選択区分型;
  @Prop({default: false})
  private disabled!: boolean;

  private 卸一覧: 卸型[] = [];

  public mounted(): void {
    this.initialize();
  }

  @Emit('input')
  private update(event: Event): string | null {
    const target = event.target as HTMLInputElement;
    if (target.value) {
      return target.value as string;
    }
    return null;
  }

  private async initialize(): Promise<void> {
    this.卸一覧 = await api.卸一覧を取得する();
  }

  private getList(): any[] {
    if (this.masterType !== マスタ選択区分型.指定なし) {
      if (this.masterType === マスタ選択区分型.採用品) {
        return this.卸一覧;
      }
      return [];
    }

    if (this.productType === 商品区分型.医薬品) {
      return this.卸一覧
        .filter((卸) => 卸.医薬品発注有効区分 === '有効')
        .map((卸) => (卸),
      );
    }
    if (this.productType === 商品区分型.その他品) {
      return this.卸一覧
        .filter((卸) => 卸.その他品発注有効区分 === '有効')
        .map((卸) => (卸),
        );
    }
    if (this.productType === 商品区分型.備蓄品) {
      return this.卸一覧
        .filter((卸) => (卸.備蓄品発注有効区分 === '有効' && 卸.備蓄センターフラグ === '備蓄センター'))
        .map((卸) => (卸),
        );
    }
    return this.卸一覧;
  }
}
